module.exports = __webpack_public_path__ + "static/img/2.7.508ceed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/picture/2.7.jpg
// module id = K4Ki
// module chunks = 7